import React, {useState} from 'react';
import {
    Box,
    CircularProgress,
    IconButton,
    makeStyles,
    Modal,
    Paper,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tabs,
    Typography
} from "@material-ui/core";
import useStyles from "../../styles/styles";
import {useQuery} from "@apollo/react-hooks";
import {gql} from "apollo-boost";
import {Alert} from "@material-ui/lab";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import theme from "../../styles/theme";
import WarningIcon from "@material-ui/icons/Warning";
import LaunchIcon from "@material-ui/icons/Launch";
import ParseResponse from "../../utils/ParseResponse";

const useBoxStyles = makeStyles({
    root: {
        '& .MuiPaper-elevation1': {
            height: '400px',
            overflow: 'scroll'
        }
    },
});

const ApiRequestLogTableShortForm = ({apiRequestId}) => {
    const classes = useStyles();
    const boxClasses = useBoxStyles();

    const [modalData, setModalData] = useState({});
    const [selectedTab, setSelectedTab] = useState(0);
    const [isLogOpen, setLogOpen] = useState(false);

    const CreateOlpLink = ({olpSessionId}) => {
        if (olpSessionId) {
            const env = process.env.NODE_ENV;

            if (env === 'development') {
                return (
                    <a target="_blank"
                       rel="noopener noreferrer"
                       href={`http://test.tools.partnerweekly.com/application/index.php?application_id=${olpSessionId}&campaign_info_id=&mode=rc`}>
                        {olpSessionId}
                    </a>
                );
            } else {
                return (
                    <a target="_blank"
                       rel="noopener noreferrer"
                       href={`http://secure.tools.partnerweekly.com/application/index.php?application_id=${olpSessionId}&campaign_info_id=&mode=slave`}>
                        {olpSessionId}
                    </a>
                );
            }
        }

        return 'N/A';
    };

    const handleOpen = (request, response) => {
        console.log('setting modal data', request, response)
        setModalData({
            request,
            response
        });
        setLogOpen(true);
    };

    const handleClose = () => {
        setModalData({});
        setLogOpen(false)
    };

    const handleTabClick = (e, val) => {
        setSelectedTab(val);
    };

    const {loading, error, data} = useQuery(gql`
        query ApiRequestLog($apiRequestId: UUID!) {
            apiRequestLog(apiRequestId: $apiRequestId) {
                dateCreated
                entityId
                message
                olpDecision
                olpSessionId
                request
                response
                statusCode
                uri
            }
        }
    `, {
        variables: {
            apiRequestId: apiRequestId,
        },
        context: {
            clientName: "kgraphql"
        }
    });

    const apiRequestLog = data?.apiRequestLog ?? {}

    if (loading) {
        return (
            <>
                <Typography variant="h4" component="h4" align="left" id={"raw-request-log"}>Raw Request
                    Log</Typography>
                <Paper className={classes.paper}>
                    <CircularProgress color="inherit"/>
                </Paper>
            </>
        );
    }

    if (!apiRequestLog || error) {
        return (
            <>
                <Typography variant="h4" component="h4" align="left" id={"raw-request-log"}>Raw Request
                    Log</Typography>
                <Paper className={classes.paper}>
                    <Alert severity="error">Well, this in embarrassing&hellip; something went wrong.</Alert>
                </Paper>
            </>
        );
    }

    return (
        <>
            <Typography variant="h4" component="h4" align="left" id={"raw-request-log"}>Raw Request
                Log</Typography>
            <Paper className={classes.paper}>
                <Table className={classes.table} size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell variant="head">URI</TableCell>
                            <TableCell variant="head">Status Code</TableCell>
                            <TableCell variant="head">Message</TableCell>
                            <TableCell variant="head">View Raw Data</TableCell>
                            <TableCell variant="head">OLP Session</TableCell>
                            <TableCell variant="head">OLP Decision</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell
                                variant="body">{apiRequestLog.uri}</TableCell>
                            <TableCell
                                variant="body">{apiRequestLog.statusCode === 200 ?
                                <CheckBoxIcon style={{color: theme.palette.success.main}}/> :
                                <WarningIcon style={{color: theme.palette.error.main}}/>}</TableCell>
                            <TableCell
                                variant="body">{apiRequestLog.message.length ? apiRequestLog.message : 'N/A'}</TableCell>
                            <TableCell variant="body">
                                <IconButton
                                    onClick={() => handleOpen(apiRequestLog.request, apiRequestLog.response)}>
                                    <LaunchIcon/>
                                </IconButton>
                            </TableCell>
                            <TableCell variant="body">
                                <CreateOlpLink
                                    olpSessionId={apiRequestLog.olpSessionId}/>
                            </TableCell>
                            <TableCell
                                variant="body">{apiRequestLog.olpDecision || 'N/A'}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Paper>
            <Modal
                open={isLogOpen}
                onClose={handleClose}
            >
                <Paper className={classes.modal}>
                    <Tabs
                        aria-label="raw data tabs"
                        value={selectedTab}
                        onChange={handleTabClick}
                        indicatorColor="primary"
                        textColor="primary"
                        centered
                    >
                        <Tab
                            label="Request Raw Tab"
                            id="raw-data-0"
                        />
                        <Tab
                            label="Response Raw Tab"
                            id="request-data-0"
                        />
                    </Tabs>
                    <Box
                        component="div"
                        role="tabpanel"
                        hidden={selectedTab !== 0}
                        className={boxClasses.root}
                    >
                        {modalData.request ? (
                            <ParseResponse data={modalData.request}/>
                        ) : null}
                    </Box>
                    <Box
                        component="div"
                        role="tabpanel"
                        hidden={selectedTab !== 1}
                        className={boxClasses.root}
                    >
                        {modalData.response ? (
                            <ParseResponse data={modalData.response}/>
                        ) : null}
                    </Box>
                </Paper>
            </Modal>
        </>
    )
};

export default ApiRequestLogTableShortForm;
